import React, { createContext, useContext, useState } from 'react';

const CurrentStageContext = createContext({ stageTitle: null, stageSubtitle: null, setStageInfo: () => {} });

export const CurrentStageProvider = ({ children }) => {
  const [stageInfo, setStageInfo] = useState({ stageTitle: null, stageSubtitle: null });
  return (
    <CurrentStageContext.Provider value={{ ...stageInfo, setStageInfo }}>
      {children}
    </CurrentStageContext.Provider>
  );
};

export const useCurrentStage = () => useContext(CurrentStageContext);

export default CurrentStageContext;
